




import Chart from "chart.js";

// @ts-ignore
Chart.defaults.global.defaultFontFamily = "'Manrope', 'sans-serif'";
// @ts-ignore
Chart.defaults.global.defaultFontColor = "#8693A0";

const options = {
  layout: {
    padding: {
      left: 15,
      right: 20,
      top: 20,
      bottom: 10
    }
  },
  elements: {
    point: {
      radius: 0,
      hitRadius: 20,
      hoverRadius: 1
    }
  },
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    position: "bottom",
    align: "end",
    fullWidth: true,
    labels: {
      padding: 24,
      usePointStyle: true,
      fontColor: "#212B36"
    }
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          padding: 15,
          fontSize: 10
        },
        gridLines: {
          drawBorder: false,
          borderDash: [3, 2],
          color: "#E7E9EC",
          zeroLineBorderDash: [3, 2],
          zeroLineColor: "#E7E9EC"
        }
      }
    ],
    xAxes: [
      {
        ticks: {
          fontSize: 10,
          padding: 15
        },
        stacked: true,
        gridLines: {
          drawBorder: false,
          borderDash: [3, 2],
          color: "#E7E9EC",
          zeroLineBorderDash: [3, 2],
          zeroLineColor: "#E7E9EC"
        }
      }
    ]
  }
};

export default {
  props: ["labels", "dataOne", "dataTwo"],
  mounted() {
    const ctxBar = document.getElementById("myChart");
    // @ts-ignore
    const myBarChart = new Chart(ctxBar, {
      type: "line",
      data: {
        labels: this.$props.labels,
        datasets: [
          {
            borderWidth: 2,
            barThickness: 2,
            borderColor: "#6D41F3",
            backgroundColor: "#6D41F3",
            label: "Unique Click Count",
            fill: false,
            data: this.$props.dataTwo
          },
          {
            borderWidth: 2,
            barThickness: 2,
            borderColor: "#F03965",
            backgroundColor: "#F03965",
            label: "Message Count",
            fill: false,
            data: this.$props.dataOne
          }
        ]
      },
      options
    });
    // @ts-ignore
    myBarChart.render();
  }
};
